import ReactOnRails from 'react-on-rails';
import PhotoCustomization from '../bundles/PhotoCustomization';

ReactOnRails.register({
  PhotoCustomization,
});

// Mount the component when modal is opened
document.addEventListener('DOMContentLoaded', function() {
  // Function to mount PhotoCustomization component
  window.mountPhotoCustomization = function(photoData, cartId) {
    const container = document.getElementById('photo-customize-component');
    if (container) {
      ReactOnRails.render('PhotoCustomization', {
        photoData: photoData,
        cartId: cartId,
        onAddToCart: async (photoId, customizations) => {
          // API call to add photo to cart using existing endpoint
          const response = await fetch('/api/v1/cart/photos', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
            },
            body: JSON.stringify({
              photo_id: photoId,
              // Store customizations in session or local storage for later retrieval
              customizations: customizations
            })
          });
          
          if (!response.ok) {
            throw new Error('Failed to add to cart');
          }
          
          // Store customizations in local storage linked to photo and cart
          localStorage.setItem(`customization_${cartId}_${photoId}`, JSON.stringify(customizations));
          
          // Refresh the page or update UI
          location.reload();
        },
        onRemoveFromCart: async (photoId) => {
          // API call to remove photo from cart using existing endpoint
          const response = await fetch('/api/v1/cart/photos', {
            method: 'DELETE',
            headers: {
              'Content-Type': 'application/json',
              'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
            },
            body: JSON.stringify({
              photo_id: photoId
            })
          });
          
          if (!response.ok) {
            throw new Error('Failed to remove from cart');
          }
          
          // Remove customizations from local storage
          localStorage.removeItem(`customization_${cartId}_${photoId}`);
          
          // Refresh the page or update UI
          location.reload();
        }
      }, container);
    }
  };

  // Event listener for customize buttons
  document.addEventListener('click', function(e) {
    if (e.target.classList.contains('customize-photo-btn')) {
      const photoData = JSON.parse(e.target.getAttribute('data-photo-data'));
      const cartId = parseInt(e.target.getAttribute('data-cart-id'));
      
      // Mount the component when modal opens
      $('#photoCustomizeModal').on('shown.bs.modal', function () {
        window.mountPhotoCustomization(photoData, cartId);
      });
    }
  });
});